// removed by extract-text-webpack-plugin
module.exports = {"index":"_20ja4VbVnsHriXZrM8_UIT","is-mobile":"wXGs6McjTD1ZWDZxKDAeQ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Gallery/index.css
// module id = 271
// module chunks = 0